import * as React from 'react';

import {convertToObj} from 'nutshell-core/filter';
import type {FilterObject} from 'nutshell-core/types';

import {SelectPickerGeneric} from 'shells/select-picker-generic/select-picker-generic';

import type {ReportURLParams} from '../../reports/report-types';

type OptionValue = {
    [key: string]: string | any;
};

export type Option = {
    value: OptionValue;
    label: string;
    isDisabled?: boolean;
};

type Props = {
    defaultOption: Option;
    options: Option[];
    activeFilterKey?: string;
    activeFilterOption?: OptionValue;
    getNewFilters: (option: Option) => FilterObject[];
    urlParams: ReportURLParams<any>;
    onParamChange: (arg1: any, arg2: boolean) => any;
};

export function GraduatedFilter(props: Props) {
    const {
        defaultOption,
        options,
        activeFilterKey,
        activeFilterOption,
        getNewFilters,
        urlParams,
        onParamChange,
    } = props;
    // Based on the active filter key, get the active option.
    // If there isn't an activeFilterKey, return the default option
    // In the case of a filter where the option keys are all the same (clickedEditionUrls)
    // we need to use the activeFilterOption to get the active option, not just the key
    let value = defaultOption;
    if (activeFilterKey && !activeFilterOption) {
        // @ts-expect-error
        value = activeFilterKey
            ? options.find((option) => Object.keys(option.value)[0] === activeFilterKey)
            : defaultOption;
    } else if (activeFilterOption) {
        value =
            options.find((option) => {
                const optionKey = Object.keys(option.value)[0];
                // @ts-expect-error
                const optionValue = option.value[optionKey];
                const activeKey = Object.keys(activeFilterOption)[0];
                // @ts-expect-error
                const activeValue = activeFilterOption[activeKey];

                return optionKey === activeKey && optionValue === activeValue;
            }) || defaultOption;
    }

    const handleChange = (option: Option) => {
        const newFilters = getNewFilters(option);

        onParamChange(
            {
                filter: convertToObj(newFilters),
                list: {
                    ...urlParams.list,
                    page: 1,
                },
            },
            false
        );
    };

    return (
        <SelectPickerGeneric
            options={options}
            styles={{
                // @ts-expect-error
                control: (base) => ({
                    ...base,
                    zIndex: 10,
                    minWidth: 200,
                    height: 31,
                    minHeight: 31,
                }),
                // @ts-expect-error
                menu: (base) => ({
                    ...base,
                    minWidth: 200,
                    zIndex: 10,
                }),
            }}
            value={value}
            isDisabled={false}
            onChange={handleChange}
        />
    );
}
